import styled from 'styled-components';
import { Flex } from '@igooods/ui-kit';
import { mediaSmDown } from '../../../theme/helpers/css';
import { colors } from '../../../constants/colors';
import { Title } from '../../Typography';
import { FontFamily, FontWeight } from '../../../theme';

const POPUP_WIDTH_DESKTOP = 558;
const POPUP_HEIGHT_DESKTOP = 528;

export const Container = styled(Flex).attrs({
  column: true,
})`
  padding: 70px 40px;
  box-sizing: border-box;
  width: ${POPUP_WIDTH_DESKTOP}px;
  height: ${POPUP_HEIGHT_DESKTOP}px;
  justify-content: center;
  align-items: center;
  ${mediaSmDown`
    width: 100%;
    padding-bottom: 0;
    padding: 0;
    height: auto;
  `}
`;

export const Image = styled.img`
  margin-bottom: 44px;
  ${mediaSmDown`
    display: none;
  `}
`;

export const PopupTitle = styled(Title).attrs({
  color: colors.blackRussian,
  fontFamily: FontFamily.secondFont,
  fontWeight: FontWeight.bold,
})`
  margin-bottom: 12px;
  font-size: 26px;
  line-height: 33px;
  letter-spacing: -0.5px;
  text-align: center;
  ${mediaSmDown`
    font-size: 20px;
    line-height: 28px;
    text-align: left;
  `}
`;

export const PopupInviteBlock = styled(Flex)`
  flex-direction: column;
  gap: 12px;
  align-items: center;
`;

export const PopupText = styled.span`
  margin-bottom: 32px;
  text-align: center;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.2px;
  color: ${colors.blackRussian};
  ${mediaSmDown`
    text-align: left;
  `}
`;
